 
import CardRh from "@/components/cards/ManzaCard.vue";
import FaltaService from "@/service/v1/sigap/FaltaService"; 
import { Options, Vue } from "vue-class-component"; 
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Multiselect from '@vueform/multiselect';
import Pdf from "./_Pdf.vue";
import { Prop } from 'vue-property-decorator';

@Options({
    name: "DisciplinaFaltaAgrupadaIndex",
    components: { CardRh, KDataTable, Multiselect, Pdf },
})
export default class DisciplinaFaltaAgrupadaIndex extends Vue {

    @Prop() readonly disciplina!: any;
    @Prop() readonly perfis!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;

    public parametros: any = null;
    public disciplinaId: any = null;
    public status_id: any = null;
    public status: any = null;
    public pelotao: any = null;
    public porcentagemMin: any = null;
    public porcentagemMax: any = null;
    public cpf = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    
    pushColunaAcoes() {
        this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.cpf = '';
        this.status_id = null;
        this.pelotao = null;
        this.porcentagemMin = null;
        this.porcentagemMax = null;
        this.refreshTable();
    }

    created() {
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new FaltaService();
        this.getStatus();
        this.disciplinaId = this.$route.params.id;
        this.config.ajax = {
            url: this.service.getApiUrl() + '/GetFaltaAgrupadas',
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    cpf: this.cpf,
                    status: this.status_id,
                    pelotao: this.pelotao,
                    disciplinaId: this.disciplinaId,
                    porcentagemMin: this.porcentagemMin,
                    porcentagemMax: this.porcentagemMax,
                    search: d.search.value,
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: 'matricula', name: 'matricula', class: 'desktop', orderable: false },
            { data: 'matricula', name: 'matricula', class: 'desktop', orderable: false },
            { data: 'matricula', name: 'matricula', class: 'desktop', orderable: false },
            { data: 'count', name: 'count', class: 'desktop', orderable: false },
            { data: 'disciplina', name: 'disciplina', class: 'desktop', orderable: false },
            { data: 'disciplina', name: 'disciplina', class: 'desktop', orderable: false },
            { data: 'disciplina', name: 'disciplina', searchable: false, class: 'text-center desktop', orderable: false },
            { data: 'porcentagem', name: 'porcentagem', searchable: false, class: 'text-center desktop' , orderable: false},
        ];
        this.config.columnDefs = [
            {
                targets: 0,
                render: (row) => {
                    return row != null ? row.usuario.nome : '';
                }
            },
            {
                targets: 1,
                render: (row) => {
                    return row != null ? row.status.nome : '';
                }
            },
            {
                targets: 2,
                render: (row) => {
                    return row != null ? row.pelotao : '';
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return row != null ? row.cargaHoraria : '';
                }
            },
            {
                targets: 5,
                render: (row) => {
                    return row != null ? row.cargaHorariaLimpa : '';
                }
            },
            {
                targets: 6,
                render: (row) => {
                    return row != null ? row.qteLimiteFalta : '';
                }
            },
            {
                targets: 7,
                render: (row) => {
                    return row != null ? `${row.toFixed(2)}% de falta` : '';
                }
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 8,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-falta ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }
}
